<template>
  <BaseCardSection title="Detail objednávky" :is-collapsible="false" :is-open="true" @validation="handleValidation">
    <div class="row g-3">
      <div class="col-12 col-md-8">
        <div class="form-group">
          <label class="form-label" for="order-text">
            Zadejte text objednávky:
            <small class="text-muted">({{ props.orderText?.length || 0 }}/2000)</small>
          </label>
          <textarea
              rows="8"
              class="form-control"
              id="order-text"
              name="order_text"
              :value="props.orderText"
              @input="$emit('update:orderText', $event.target.value)"
              maxlength="2000"
              placeholder="Zadejte podrobný popis objednávky, specifikace, požadavky zákazníka..."
              v-validate="{
                   rules: { required: true},
                   message: { required: 'Text objednávky je povinný'},
                   options: { showValidState: false }
                 }"
          ></textarea>
        </div>
      </div>
      <div class="col col-md-4 px-md-4" style="margin-top: 30px">
        <table class="table mb-0">
          <tbody>
          <tr>
            <td class="text-muted py-2 ps-4">
              Záloha včetně DPH
            </td>
            <td class="text-end pe-4 fw-bold fs-6">
              {{ props.proformaValueAbsolute ? formatFloat(props.proformaValueAbsolute, 2) : '0,00' }} <span
                class="text-muted">Kč</span>
            </td>
          </tr>
          <tr>
            <td class="text-muted py-2 ps-4">
              Celková cena bez DPH
            </td>
            <td class="text-end pe-4 fw-bold fs-6">
              {{ props.totalPriceWithoutVat }} <span class="text-muted">Kč</span>
            </td>
          </tr>
          <tr>
            <td class="text-muted py-2 ps-4">
              Sazba DPH
            </td>
            <td class="text-end pe-4 fw-bold fs-6">
              {{ props.vat }} <span class="text-muted">%</span>
            </td>
          </tr>
          <tr>
            <td class="text-muted py-2 ps-4">
              DPH
            </td>
            <td class="text-end pe-4 fw-bold fs-6">
              {{ props.totalVat }} <span class="text-muted">Kč</span>
            </td>
          </tr>
          <tr>
            <td class="text-muted py-2 ps-4">
              Korekce DPH
            </td>
            <td class="text-end pe-4 fw-bold fs-6">
              {{ props.vatCorrection }} <span class="text-muted">Kč</span>
            </td>
          </tr>
          <tr>
            <td class="text-muted py-2 ps-4">
              Celková cena s DPH
            </td>
            <td class="text-end pe-4 fw-bold fs-6">
              {{ props.totalPriceWithVatRounded }} <span class="text-muted">Kč</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </BaseCardSection>
</template>

<script setup>
import {defineProps, defineEmits, ref} from 'vue';
import BaseCardSection from "@/components/base/BaseCardSection.vue";
import {formatFloat} from "@/common/functions";

// Definice props pro jednosměrný tok dat a pro v-model
const props = defineProps({
  // Pro v-model:orderText
  orderText: {
    type: String,
    default: ''
  },
  // Ostatní data z výpočtů (jednosměrná, ale reaktivní)
  proformaValueAbsolute: [Number, String],
  totalPriceWithoutVat: [Number, String],
  vat: [Number, String],
  totalVat: [Number, String],
  vatCorrection: [Number, String],
  totalPriceWithVatRounded: [Number, String]
});

const fieldStatus = ref({});

// Definice událostí pro v-model
const emit = defineEmits(['update:orderText', 'update:isSectionValid']);

const handleValidation = (event) => {
  const { fieldName, isValid } = event.detail;

  // Uložíme stav konkrétního pole
  fieldStatus.value[fieldName] = isValid;

  // Sekce je validní pouze pokud jsou VŠECHNA registrovaná pole true
  const isSectionValid = Object.values(fieldStatus.value).every(status => status === true);

  emit('update:isSectionValid', isSectionValid);
};

</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}

.form-label {
  font-weight: 500;
}

textarea {
  resize: vertical;
}

.table td {
  border-bottom: 1px solid #f8f9fa;
}

/* Ladění vzhledu pro součtovou tabulku */
.text-muted {
  font-size: 0.9rem;
}
</style>